module.exports = __webpack_public_path__ + "static/media/logout-success@3x.9212b.png";